<!-- VIN Details Block starts here -->
<div #vinOverlay id="vin-overlay" (click)="onVehicleImageOverlayClick()"></div>
<div [hidden]="windowWidth < 768 || !isInternal" id="vin-details">
    <div class="vehicle-image" style="display: none;" [ngStyle]="{'display':vinImage ? 'block':'none'}">
        <mat-card class="example-card vehicle-image-card" (click)="onVehicleImageClick(false);">
            <img [alt]="vinImage" class="cursor-pointer vin-image" mat-card-image *ngIf="vinImage" [src]="vinImage">
            <span *ngIf="vinImage" class="vin-disclaimer">Click here to see VIN Details</span>
        </mat-card>
    </div>

    <div *ngIf="showVINDetails" data-collapsed="true" class="vehicle-details-block">
        <div class="resource-container-wrapper vin-wrapper" id="vin-container-wrapper">
            <div class="col-sm-12 section-wrapper" #vinSectionDetails id="vinSectionDetails">
                <h3 class="section-title vehicle-section-title">
                    <span class="float-left vin-header">Vehicle Details</span>
                    <span class="float-right cursor-pointer" (click)="onVehicleImageClick(false);">
                        <mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
                    </span>
                </h3>
                <div class="section-content">
                    <ul *ngIf="vehicleDetails">
                        <li class="vehicle-list" *ngFor="let x of vehicleDetails;let i=index;">
                            <span class="vehicle-list-name float-left">{{x.name}}</span>
                            <span class="vehicle-list-value float-right ml-auto">{{x.value}}</span>
                            <mat-divider *ngIf="i !== 0 && i !== vehicleDetails.length-1" style="margin: 5px 0;">
                            </mat-divider>
                        </li>
                        <li class="mt-4"
                            [ngClass]="hideCapabilities ? 'vin-capabilities-details' : 'vin-capabilities-details-expanded'"
                            mode="side" *ngIf="vinCapabilityDetails && vinCapabilityDetails.length >0">
                            <span class="mr-2 float-left cursor-pointer">
                                <mat-icon *ngIf="hideCapabilities"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">add_circle_outline</mat-icon>
                                <mat-icon *ngIf="!hideCapabilities"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">remove_circle_outline
                                </mat-icon>
                            </span>
                            <div *ngIf="appName=== 'toyota' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">Connected Services
                                    Capabilities</span>

                            </div>
                            <div *ngIf="appName==='lexus' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">Capabilities</span>
                            </div>

                            <div class="section-content" [hidden]="hideCapabilities">
                                <ul *ngIf="vinCapabilityDetails && vinCapabilityDetails.length >0">
                                    <li class="vehicle-capabilities-list"
                                        *ngFor="let capability of vinCapabilityDetails;let a=index;let last = last;"
                                        [class.vehicle-capabilities-list-last]="last">
                                        <span
                                            class="vehicle-list-name capability-name float-left">{{capability.displayName
                                            === ' '? capability.name : capability.displayName}}</span>
                                        <a (click)="vinSectionDetails.scrollTop = 0;"
                                            class="float-right scroll-top-icon cursor-pointer"
                                            *ngIf="a === vinCapabilityDetails.length-1">
                                            <mat-icon style="font-size: 30px;">arrow_circle_up</mat-icon>
                                        </a>
                                        <mat-divider *ngIf="a !== 0 && a !== vinCapabilityDetails.length-1"
                                            style="margin: 5px 0;"></mat-divider>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="mt-4"
                            [ngClass]="hideRemoteCapabilities ? 'remote-capabilities-details' : 'remote-capabilities-details-expanded'"
                            mode="side" *ngIf="remoteCapabilityDetails && remoteCapabilityDetails.length >0">
                            <span class="mr-2 float-left cursor-pointer">
                                <mat-icon *ngIf="hideRemoteCapabilities"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">add_circle_outline
                                </mat-icon>
                                <mat-icon *ngIf="!hideRemoteCapabilities"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">remove_circle_outline
                                </mat-icon>
                            </span>
                            <div *ngIf="appName=== 'toyota' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">Remote Connect
                                    Capabilities</span>
                            </div>
                            <div *ngIf="appName==='lexus' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">Remote Connect
                                    Capabilities</span>
                            </div>

                            <div class="section-content" [hidden]="hideRemoteCapabilities">
                                <ul *ngIf="remoteCapabilityDetails && remoteCapabilityDetails.length >0">
                                    <li class="vehicle-capabilities-list"
                                        *ngFor="let capability of remoteCapabilityDetails;let a=index;let last = last;"
                                        [class.vehicle-capabilities-list-last]="last">
                                        <span
                                            class="vehicle-list-name capability-name float-left">{{capability.name}}</span>
                                        <a (click)="vinSectionDetails.scrollTop = 0;"
                                            class="float-right scroll-top-icon cursor-pointer"
                                            *ngIf="a === remoteCapabilityDetails.length-1">
                                            <mat-icon style="font-size: 30px;">arrow_circle_up</mat-icon>
                                        </a>
                                        <mat-divider *ngIf="a !== 0 && a !== remoteCapabilityDetails.length-1"
                                            style="margin: 5px 0;"></mat-divider>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div [hidden]="windowWidth >= 768 || !isInternal" id="vin-details" class="vehicle-responsive-image" style="display: none;"
    [ngStyle]="{'display':vinImage ? 'block':'none'}">
    <mat-card (click)="onVehicleImageClick(true);" class="example-card vehicle-image-card">
        <img [alt]="vinImage" class="cursor-pointer vin-image" mat-card-image *ngIf="vinImage" [src]="vinImage">
        <span *ngIf="vinImage" class="vin-disclaimer">Click here to see VIN Details</span>
    </mat-card>
    <div *ngIf="showVINDetails" data-collapsed="true" class="vehicle-details-block">
        <div class="resource-container-wrapper vin-responsive-wrapper" id="vin-container-wrapper">
            <div class="col-sm-12 section-wrapper" #vinSectionDetails>
                <h3 class="section-title vehicle-section-title">
                    <span class="float-left vin-header">Vehicle Details</span>
                    <a class="float-right cursor-pointer" (click)="onVehicleImageClick(false,false);">
                        <mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
                    </a>
                </h3>
                <div class="section-content">
                    <ul *ngIf="vehicleDetails">
                        <li class="vehicle-list" *ngFor="let x of vehicleDetails;let i=index;">
                            <span class="vehicle-list-name float-left">{{x.name}}</span>
                            <span class="vehicle-list-value float-right ml-auto">{{x.value}}</span>
                            <mat-divider *ngIf="i !== 0 && i !== vehicleDetails.length-1" style="margin: 5px 0;">
                            </mat-divider>
                        </li>
                        <li class="mt-4"
                            [ngClass]="hideCapabilities ? 'vin-capabilities-details' : 'vin-capabilities-details-expanded'">
                            <span class="mr-2 float-left">
                                <mat-icon *ngIf="hideCapabilities"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">add_circle_outline</mat-icon>
                                <mat-icon *ngIf="!hideCapabilities"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">remove_circle_outline
                                </mat-icon>
                            </span>
                            <div *ngIf="appName==='toyota'">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">Connected Services
                                    Capabilities</span>
                            </div>
                            <div *ngIf="appName==='lexus'">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('vinCapabilityDetails');">Capabilities</span>
                            </div>
                            <div class="section-content" [hidden]="hideCapabilities">
                                <ul *ngIf="vinCapabilityDetails && vinCapabilityDetails.length >0">
                                    <li class="vehicle-capabilities-list"
                                        *ngFor="let capability of vinCapabilityDetails;let a=index;let last = last;"
                                        [class.vehicle-capabilities-list-last]="last">
                                        <span
                                            class="vehicle-list-name capability-name float-left">{{capability.displayName
                                            === ' '? capability.name : capability.displayName}}</span>
                                        <a (click)="vinSectionDetails.scrollTop = 0;"
                                            class="float-right scroll-top-icon cursor-pointer"
                                            *ngIf="a === vinCapabilityDetails.length-1">
                                            <mat-icon (click)="scrollTopInImage();" style="font-size: 30px;">
                                                arrow_circle_up</mat-icon>
                                        </a>
                                        <mat-divider *ngIf="a !== 0 && a !== vinCapabilityDetails.length-1"
                                            style="margin: 5px 0;"></mat-divider>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="mt-4" *ngIf="remoteCapabilityDetails && remoteCapabilityDetails.length >0" [ngClass]="hideRemoteCapabilities ? '' : 'remote-capabilities-details-expanded'">
                            
                            <span class="mr-2 float-left cursor-pointer">
                                <mat-icon *ngIf="hideRemoteCapabilities"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">add_circle_outline
                                </mat-icon>
                                <mat-icon *ngIf="!hideRemoteCapabilities"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">remove_circle_outline
                                </mat-icon>
                            </span>
                            <div *ngIf="appName=== 'toyota' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">Remote Connect
                                    Capabilities</span>
                            </div>
                            <div *ngIf="appName==='lexus' ">
                                <span class="vehicle-list-name capability-header cursor-pointer"
                                    (click)="toggleCapabilities('remoteCapabilityDetails');">Remote Connect
                                    Capabilities</span>
                            </div>

                            <div class="section-content" [hidden]="hideRemoteCapabilities">
                                <ul *ngIf="remoteCapabilityDetails && remoteCapabilityDetails.length >0">
                                    <li class="vehicle-capabilities-list"
                                        *ngFor="let capability of remoteCapabilityDetails;let a=index;let last = last;"
                                        [class.vehicle-capabilities-list-last]="last">
                                        <span
                                            class="vehicle-list-name capability-name float-left">{{capability.name}}</span>
                                        <a (click)="vinSectionDetails.scrollTop = 0;"
                                            class="float-right scroll-top-icon cursor-pointer"
                                            *ngIf="a === remoteCapabilityDetails.length-1">
                                            <mat-icon style="font-size: 30px;">arrow_circle_up</mat-icon>
                                        </a>
                                        <mat-divider *ngIf="a !== 0 && a !== remoteCapabilityDetails.length-1"
                                            style="margin: 5px 0;"></mat-divider>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="dashboard" *ngIf="!previewFlow" class="flow content-block-height lessen-margin">

    <div class="col-12 p-0">
        <div class="row m-0 p-0" [ngClass]="{'col-12':appName === 'lexus'}">

            <div class="col-12 p-0">

                <div class="first-guide-back-img" *ngIf="vehicleGeneration && vehicleGeneration.name === '21MM'" [ngStyle]="imgStyleObject()" >
                    <div *ngIf="vehicleGeneration && vehicleGeneration.name === '21MM'" [ngClass]="{'first-content' : appName === 'toyota', 'lex-first-content' : appName === 'lexus'}">
                        <br/>
                        <div [ngClass]="{'align-center-container' : appName === 'toyota', 'lex-align-center-container' : appName === 'lexus'}">
                        </div>
                        <div style="margin-top:0px;margin-bottom:0px;" [ngClass]="{'align-center-container' : appName === 'toyota', 'lex-align-center-container' : appName === 'lexus'}" >
                            <a href="{{firstSetupPath}}" rel="noopener noreferrer" target="_blank">
                                <!-- <button type="button" name="get-started" class="btn getstarted-btn learn-more-btn" [ngClass]="{'align-center-container' : appName === 'toyota'}">{{
                                    "Button.learn_more" | translate}}
                                </button> -->
                            </a>
                        </div>
                        <div class="darken-background" [ngClass]="{'align-center-container' : appName === 'toyota', 'lex-align-center-container' : appName === 'lexus'}">
                        </div>
                    </div>
                </div>
                <br/>
                <span class="dashbord-information">
                    <div class="information-text flow-content-text col-12">
                        <div class="question-text-cts">{{ "Label.question_issue_cts" | translate}}
                            <sup>
                                <span class="fa fa-info-circle" style="font-size: 14px;"
                                    (click)="showDisclaimer()"></span>
                            </sup>
                            <div *ngIf="appName === 'toyota'" class="disclaimer">{{"Label.disclaimer_toyota" |
                                translate}}</div>
                            <div *ngIf="appName === 'lexus'" class="disclaimer">{{"Label.disclaimer_lexus" | translate}}
                            </div>
                        </div>
                    </div>
                </span>
   
                <div class="inner-wrapper" *ngIf="isCategoryMapping">
                  
                    <div *ngFor="let cat of categories">


                        <div class="row  align-items-center" *ngIf="cat === 'audioFeatures'">

                            <div class="col-1"></div>
                            <div class="col-10 align-items-left">
                                <div class="audio-multimedia-heading-section">

                                    <p class="audio-multimedia-heading"
                                        [hidden]="(appName === 'toyota') || (vehicleGeneration.name === '21MM')">Lexus
                                        Multimedia</p>
                                    <p class="audio-multimedia-heading"
                                        [hidden]="(appName === 'toyota') || (vehicleGeneration.name !== '21MM')">Lexus
                                        Interface</p>
                                    <p class="audio-multimedia-heading audio-multimedia-header"
                                        [hidden]="appName === 'lexus'">Audio Multimedia</p>
                                </div>
                                </div>
                        </div>
                        <div class="row align-items-center" *ngIf="cat === 'audioFeatures'">
                            <div class="col-1" [hidden]="windowWidth < 768">
                                
                            </div>
                                <div class="col-10 dash-wrapper" >
                                    <button class="arrow__btn" (click)="sideScroll('right', cat)"><</button>
                                    <div class="dash-wrapper" [id]="'horizontal-scrolling-wrapper-'+cat">
                                        
                                        <div class="card dash-item no-border" (mouseenter)="showActive($event , feat && feat.status)" (mouseleave)="showInactive($event)"
                                            *ngFor="let feat of audioFeatures | sort:'asc':'order'; index as indexOfelement;">
                                            <a (click)="feat.status != 'draft'?onFeatureSelection(feat): '' "
                                                class="tile one new-category-tile">
                                                <div class="service-img"
                                                    [ngStyle]="feat.status === 'draft' ? {'opacity': '0.3'}: '' ">
                                                    <div class="tile-content" #actionInfoTooltip="matTooltip"
                                                        [ngStyle]="feat.status === 'draft' ? {'cursor': 'default'} : {'cursor': 'pointer'} "
                                                        [matTooltip]="feat.status === 'draft'? (feat.draftCategory && feat.draftCategory.draftMessage && feat.draftCategory.draftMessage !== '' ? feat.draftCategory.draftMessage : tip) : '' "
                                                        matTooltipPosition="above" matTooltipShowDelay="100"
                                                        matTooltipHideDelay="1500"
                                                        [matTooltipClass]="{ 'tooltip-class-toyota' : isToyota , 'tooltip-class-lexus' : !isToyota }"
                                                        (mouseenter)="hideTooltipIn(actionInfoTooltip, 2000, true, indexOfelement, 0)"
                                                        (mouseleave)="hideTooltipIn(actionInfoTooltip, 2000, false, indexOfelement, 0)"
                                                        (click)="feat.status != 'draft'?onFeatureSelection(feat): hideTooltipIn(actionInfoTooltip, 2000, true, indexOfelement, 0)">
                                                        <img class="new-banner-icon" width="150" height="150"
                                                            *ngIf="showNewIcon(feat);" alt="NEW" [src]="newBannerImageURL">
                                                        <div class="service-img-overlay">
                                                            <img class="service-support-topic-image"
                                                                style="max-width: 70%;max-height: 51px;transition: transform 0.5s;"
                                                                [src]="getUrl(feat.icon)" alt="Android Auto">
                                                        </div>
                                                    </div>
                                                    <p class="support-topic-name-block" id="{{feat.controlName}}-block"
                                                        [ngClass]="[feat.status === 'draft' ? 'supporttopic-draft-text' : 'published-text', feat.controlName ? getSupportTopicClassName(feat.controlName,'text'):'',checkDriveConnectExistence(feat) ? 'drive-connect-support-block' : '']">
                                                        {{feat.controlName}}
                                                    </p>
                                                </div>
                                            </a>
                                            <span class="driver-connect-under-text" *ngIf="showDriverConnectText(feat)"
                                                [ngStyle]="feat.status === 'draft' ? {'opacity': '0.3'} :  {'opacity': '1'}"
                                                [ngClass]="[feat.controlName ? getDriveConnectClassName(feat.controlName) :'']">
                                                Drive Connect
                                                <span class="fa fa-info-circle"
                                                    (mouseenter)="driveConnectMouseEnter($event,feat.controlName)"
                                                    (mouseleave)="driveConnectMouseLeave($event,feat);"
                                                    [ngClass]="feat.status === 'draft' ? 'cursor-default' : 'cursor-pointer'"
                                                    style="font-size: 14px;"
                                                    (click)="feat.status != 'draft'? openDriveConnectPopup($event,feat.controlName) : '' ">
                                                </span>
                                            </span>
                                        </div>
                                        
                                    </div>
                                    <button class="arrow__btn" (click)="sideScroll('left', cat)">></button>
                                </div>
                            <div class="col-1 " [hidden]="windowWidth < 768">
                            </div>
                        </div>
                       
                        <div class="row align-items-end">
                        </div>
                        <div class="row  align-items-center" *ngIf="cat === 'connectedFeatures'">
                            <div class="col-1"></div>
                            <div class="col-10 align-items-left">

                                <div class="audio-multimedia-heading-section">
                                    <p class="audio-multimedia-heading audio-multimedia-header"
                                        [hidden]="appName === 'lexus'">Connected Services</p>
                                    <p class="audio-multimedia-heading audio-multimedia-header"
                                        [hidden]="(appName === 'toyota') || (vehicleGeneration.name === '21MM')">Enform
                                        Services</p>
                                    <p class="audio-multimedia-heading audio-multimedia-header"
                                        [hidden]="(appName === 'toyota') || (vehicleGeneration.name !== '21MM')">
                                        Interface Services</p>
                                </div>
                                </div>
                        </div>
                        <div class="row  align-items-center" *ngIf="cat === 'connectedFeatures'">    
                            <div class="col-1" [hidden]="windowWidth < 768">
                            </div>
                            <div class="col-10 dash-wrapper" >
                                <button class="arrow__btn" (click)="sideScroll('right', cat)"><</button>
                                <div class="dash-wrapper" [id]="'horizontal-scrolling-wrapper-'+cat">
                                    
                                    <div class="card dash-item no-border" (mouseenter)="showActive($event , feat && feat.status)" (mouseleave)="showInactive($event)"
                                        *ngFor="let feat of connectedFeatures | sort:'asc':'order'; index as indexOfelement;">
                                        <a (click)="feat.status != 'draft'?onFeatureSelection(feat): '' "
                                            class="tile one new-category-tile">
                                            <div class="service-img"
                                                [ngStyle]="feat.status === 'draft' ? {'opacity': '0.3'}: '' ">
                                                <div class="tile-content" #actionInfoTooltip="matTooltip"
                                                    [ngStyle]="feat.status === 'draft' ? {'cursor': 'default'} : {'cursor': 'pointer'} "
                                                    [matTooltip]="feat.status === 'draft'? (feat.draftCategory && feat.draftCategory.draftMessage && feat.draftCategory.draftMessage !== '' ? feat.draftCategory.draftMessage : tip) : '' "
                                                    matTooltipPosition="above" matTooltipShowDelay="100"
                                                    matTooltipHideDelay="1500"
                                                    [matTooltipClass]="{ 'tooltip-class-toyota' : isToyota , 'tooltip-class-lexus' : !isToyota }"
                                                    (mouseenter)="hideTooltipIn(actionInfoTooltip, 2000, true, indexOfelement, 0)"
                                                    (mouseleave)="hideTooltipIn(actionInfoTooltip, 2000, false, indexOfelement, 0)"
                                                    (click)="feat.status != 'draft'?onFeatureSelection(feat): hideTooltipIn(actionInfoTooltip, 2000, true, indexOfelement, 0)">
                                                    <img class="new-banner-icon" width="150" height="150"
                                                        *ngIf="showNewIcon(feat);" alt="NEW" [src]="newBannerImageURL">
                                                    <div class="service-img-overlay">
                                                        <img class="service-support-topic-image"
                                                            style="max-width: 70%;max-height: 51px;transition: transform 0.5s;"
                                                            [src]="getUrl(feat.icon)" alt="Android Auto">
                                                    </div>
                                                </div>
                                                <p class="support-topic-name-block" id="{{feat.controlName}}-block"
                                                    [ngClass]="[feat.status === 'draft' ? 'supporttopic-draft-text' : 'published-text', feat.controlName ? getSupportTopicClassName(feat.controlName,'text'):'',checkDriveConnectExistence(feat) ? 'drive-connect-support-block' : '']">
                                                    {{feat.controlName}}
                                                </p>
                                            </div>
                                        </a>
                                        <span class="driver-connect-under-text" *ngIf="showDriverConnectText(feat)"
                                            [ngStyle]="feat.status === 'draft' ? {'opacity': '0.3'} :  {'opacity': '1'}"
                                            [ngClass]="[feat.controlName ? getDriveConnectClassName(feat.controlName) :'']">
                                            Drive Connect
                                            <span class="fa fa-info-circle"
                                                (mouseenter)="driveConnectMouseEnter($event,feat.controlName)"
                                                (mouseleave)="driveConnectMouseLeave($event,feat);"
                                                [ngClass]="feat.status === 'draft' ? 'cursor-default' : 'cursor-pointer'"
                                                style="font-size: 14px;"
                                                (click)="feat.status != 'draft'? openDriveConnectPopup($event,feat.controlName) : '' ">
                                            </span>
                                        </span>
                                    </div>
                                   
                                </div>
                                <button class="arrow__btn" (click)="sideScroll('left', cat)">></button>
                            </div>
                                <div class="col-1" [hidden]="windowWidth < 768">
                        <div class="row align-items-end">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1 p-0 " [ngStyle]="{ 'visibility': 'hidden'}">
            </div>
        </div>
        <div class="container-tile-block" *ngIf="windowWidth >= 768 && !isCategoryMapping">
            <div class="tile-block"
                [ngClass]="[(features.length <= 5) ? 'stdWidth':'desktopWidth',  (windowWidth >= 768) ? 'card-deck':'tile-display']">
                <app-tile [control]="feat"
                    (click)="feat.status != 'draft'?onFeatureSelection(feat): '' "
                    *ngFor="let feat of features">
                </app-tile>
            </div>
        </div>
        <div class="row" *ngIf="windowWidth < 768 && !isCategoryMapping">
            <div class="col-12">
                <div class="container-tile-block">
                    <div class="tile-block"
                        [ngClass]="[(features.length <= 5) ? 'stdWidth':'desktopWidth',  (windowWidth >= 768) ? 'card-deck':'tile-display']">
                        <app-tile [control]="feat"
                            (click)="feat.status != 'draft'?onFeatureSelection(feat): '' "
                            *ngFor="let feat of features">
                        </app-tile>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="previewFlow">
    <app-flow-information></app-flow-information>
</div>